export const BASENAME = "/";
export const REST_API =
  "https://web-campboard-backend-prod-chn-dev.azurewebsites.net";
//export const REST_API = "web-campboard-backend-prod-chn-dev.azurewebsites.net";
//export const REST_API = "https://wa-campboard-backend-prod.azurewebsites.net";
//export const REST_API = "http://localhost:8090";
export const APP_VERSION = {
  FRONTEND: {
    VERSION: "1.2.1",
    IS_NIGHTLY: false,
  },
  BACKEND: "2.0.0",
};
export const UPLOADS = {
  TASK_CONTENT: {
    ALLOWED_EXTENSIONS:
      ".7zip, .apk, .css, .csv, .dmg, .exe, .html, .json, .mp3, .mp4, .ogg, .pdf, .rar, .tar, .txt, .wav, .docx, .docm, .dotx, .docb, .xls, .xlsx, .xlsm, .xlsb, .xltx, .xml, .zip, .mov, .wmv, .avi, .flv, .f4v, .swf, .webm, .mkv, .png, .gif, .bmp, .jpeg, .svg, .tiff",
    IMAGE_EXTENSIONS: [".png", ".gif", ".bmp", ".jpeg", ".svg", ".tiff"],
  },
};

export const goBackInHistory = (props) => {
  props.history.goBack();
};
